import FeaturedProductCard from "./FeaturedProductCard"

export default FeaturedProductCard